/**
 * Adds the static root to an asset's base path
 * @param {string} basePath - The asset's base path
 * @return {string} The full url to the static resource
 */
export default function staticPathFilter(basePath) {
    return `${ globals.config.static }${ basePath }`;
}
